// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"form-stepper_wrapper_1zPF3","item":"form-stepper_item_kK-Oz","active":"form-stepper_active_O2lgf"};